import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, FormGroup, FormControl } from 'react-bootstrap';
import TestStatusTableRow from 'containers/request/Initial/TestStatusTableRow';
import { handleInputChange } from 'actions/request';
import { fetchAuthorizedLabs } from 'actions/labs';
import { startPreloader, finishPreloader } from 'actions/preloader';

class LabTestInfo extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedLab: 0 };
  }

  componentDidMount() {
    const { startPreloader, fetchAuthorizedLabs } = this.props;

    startPreloader().then(fetchAuthorizedLabs().then(this.fetchCallback));
  }

  fetchCallback = () => {
    const { request, finishPreloader } = this.props;
    const { cdmaLab } = request;

    // fetch user lab list, if user in edit mode
    // if (cdmaLabPoc !== 0 && cdmaLab > 0) {
    if (cdmaLab > 0) {
      this.setState({ selectedLab: cdmaLab });
    }

    finishPreloader();
  };

  renderLabList() {
    // sort labs by their names before iterating
    const list = _.sortBy(this.props.labs, ['name']);

    return _.map(list, lab => {
      return (
        <option value={lab.id} key={lab.id}>
          {lab.name}
        </option>
      );
    });
  }

  // renderLabPocList() {
  //   const { selectedLab } = this.state;
  //   if (selectedLab) {
  //     const { labs } = this.props;
  //     const pocList = labs[selectedLab].casusers;

  //     if (pocList.length > 0) {
  //       return _.map(pocList, poc => {
  //         return (
  //           <option value={poc.id} key={poc.id}>
  //             {`${poc.firstname} ${poc.lastname}`}
  //           </option>
  //         );
  //       });
  //     }
  //   }
  // }

  onLabSelect = event => {
    const labId = Number(event.target.value);
    this.setState({ selectedLab: labId });
    this.props.handleInputChange(event);
  };

  render() {
    const { request, editable, labs, tests } = this.props;

    if (_.isEmpty(labs)) {
      return null;
    }

    const showStatus = !_.isEmpty(tests);

    return (
      <Table striped condensed hover>
        <thead>
          <tr>
            <th>Test Module</th>
            <th>Lab</th>
            {/* <th>Point of Contact</th> */}
            {showStatus && <th>Status</th>}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="col-xs-3 col-sm-3 col-md-3">WINNF-TS-0122</td>
            <td className="col-xs-6 col-sm-6 col-md-6">
              <FormGroup controlId="cdmaLab">
                <FormControl
                  componentClass="select"
                  value={request.cdmaLab}
                  onChange={this.onLabSelect}
                  disabled={!editable}
                >
                  <option value="0">--- Select a lab ---</option>
                  {this.renderLabList()}
                </FormControl>
              </FormGroup>
            </td>
            {/* <td>
              <Col>
                <FormGroup controlId="cdmaLabPoc">
                  <FormControl
                    componentClass="select"
                    onChange={handleInputChange}
                    value={request.cdmaLabPoc}
                    disabled={!editable || request.cdmaLab === 0}
                  >
                    <option value="0">--- Select a POC ---</option>
                    <option value="">- All -</option>
                    {this.renderLabPocList()}
                  </FormControl>
                </FormGroup>
              </Col>
            </td> */}
            <TestStatusTableRow />
          </tr>
        </tbody>
      </Table>
    );
  }
}

function mapStateToProps({ request, labs, tests }) {
  return { request, labs, tests };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange,
    fetchAuthorizedLabs,
    startPreloader,
    finishPreloader
  }
)(LabTestInfo);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/LabTestInfo.js